import React, { memo } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../hooks/useAuth";
import { useMigrationSession } from "../../hooks/useMigrationSession";
import { useLoyaltyPermission } from "../../hooks/useLoyaltyPermission";

import HeaderUserAvatar from "./HeaderUserAvatar";
import HeaderMigrationInfo from "./HeaderMigrationInfo";
import HeaderPartnerLevel from "./HeaderPartnerLevel";
import HeaderCartsMigrationInfo from "./HeaderCartsMigrationInfo";
import HeaderDemoResult from "./HeaderDemoResult";

import { Container } from "./styles";

const HeaderUserMenu = () => {
  const migration = useMigrationSession();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isLoyalty = useLoyaltyPermission();

  const isWizardRoute = pathname?.includes("/wizard/");

  return (
    <Container>
      {isWizardRoute && (
        <>
          <HeaderCartsMigrationInfo migration={migration} />

          <HeaderMigrationInfo
            title="ID:"
            subTitle={migration?.id || "-"}
            tooltipTitle="Please use this number to reference your migration when communicating with our Customer Success Team"
          />
        </>
      )}

      {migration?.has_demo_results && isWizardRoute && (
        <HeaderDemoResult migration={migration} />
      )}

      {isLoyalty && <HeaderPartnerLevel level={user?.loyalty_level} />}

      <HeaderUserAvatar />
    </Container>
  );
};

export default memo(HeaderUserMenu);
